import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
import p1 from "../../../assets/image_projets/reas1.jpeg";
import p2 from "../../../assets/image_projets/reas2.jpeg";
import p3 from "../../../assets/image_projets/reas3.jpeg";

export default function ReassproProject() {
    const images = [p2, p3];
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const nextImage = () => {
        setCurrentImageIndex((prev) => (prev + 1) % images.length);
    };

    const prevImage = () => {
        setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="relative flex flex-col lg:flex-row gap-8 lg:gap-12 items-center mb-20 lg:mb-32"
        >
            {/* Content Section (Left) */}
            <div className="w-full lg:w-[40%] space-y-6 order-2 lg:order-1">
                {/* Title */}
                <motion.h3
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2 }}
                    className="text-4xl sm:text-5xl md:text-6xl font-bold text-white"
                >
                    Reasspro Web
                </motion.h3>

                {/* Description */}
                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.3 }}
                    className="text-gray-300 text-base sm:text-lg leading-relaxed"
                >
                    Notre logiciel métier de réassurance couvre l’ensemble du cycle de vie des opérations, de la souscription à la clôture d’exercice.

                    Il prend en charge la gestion complète des acceptations et des rétrocessions, incluant la souscription, le suivi des sinistres, la gestion des règlements, le pilotage des provisions techniques ainsi que la production des états de clôture et de reporting.


                </motion.p>

                {/* Problem - Solution - Impact */}
                {/* <div className="space-y-4 pt-4">
                    <div className="space-y-2">
                        <h4 className="text-lg sm:text-xl font-semibold text-blue-400">🎯 Problématique</h4>
                        <p className="text-gray-400 text-sm md:text-base leading-relaxed">
                            Les utilisateurs au Togo ont besoin d'une solution rapide et sécurisée pour effectuer des transactions financières via mobile, avec une interface simple accessible à tous.
                        </p>
                    </div>

                    <div className="space-y-2">
                        <h4 className="text-lg sm:text-xl font-semibold text-cyan-400">💡 Solution</h4>
                        <p className="text-gray-400 text-sm md:text-base leading-relaxed">
                            Application mobile native développée avec Flutter, intégrant les plateformes Mixx by YAS et Moov avec une interface intuitive permettant des transactions en quelques clics.
                        </p>
                    </div>

                    <div className="space-y-2">
                        <h4 className="text-lg sm:text-xl font-semibold text-green-400">📈 Impact</h4>
                        <p className="text-gray-400 text-sm md:text-base leading-relaxed">
                            Facilitation des transferts d'unités de crédit pour des utilisateurs. Application open source pour paratager notre savoir faire avec la communaute dev togolaise.
                        </p>
                    </div>
                </div> */}

                {/* Technologies */}
                <div className="pt-4">
                    <h4 className="text-sm sm:text-base font-semibold text-gray-400 mb-3 uppercase tracking-wider">Technologies</h4>
                    <div className="flex flex-wrap gap-2">
                        {["Django", "Python", "HTML", "CSS", "JS", "Bootstrap", "HTMX"].map((tech, index) => (
                            <span
                                key={index}
                                className="px-3 py-1.5 bg-white/5 backdrop-blur-md border border-white/10 rounded-full text-xs sm:text-sm text-gray-300 hover:bg-white/10 hover:border-white/20 transition-all duration-300"
                            >
                                {tech}
                            </span>
                        ))}
                    </div>
                </div>

                {/* <div>
                    <button
                        onClick={() => window.open("https://mobse.myriade-groupe.com/", "_blank")}
                        className="w-[220px] sm:w-[280px] cursor-pointer px-6 py-2 sm:px-8 sm:py-5 text-center text-[12px] sm:text-lg font-medium group relative bg-white/80 text-black font-semibold rounded-full overflow-hidden transition-all duration-300 hover:border-blue-500/50 hover:bg-yellow-500"
                    >
                        Voir le site web
                    </button>
                </div> */}

            </div>

            {/* Image Carousel Section (Right) */}
            <div className="w-full lg:w-[60%] relative group order-1 lg:order-2">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl border border-white/10 bg-gradient-to-br from-cyan-900/20 to-blue-900/20">
                    {/* Image Container */}
                    <div className="relative h-[400px] sm:h-[500px] lg:h-[600px]">
                        <AnimatePresence mode="wait">
                            <motion.img
                                key={currentImageIndex}
                                src={images[currentImageIndex]}
                                alt={`Mobse screenshot ${currentImageIndex + 1}`}
                                initial={{ opacity: 0, x: 100 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -100 }}
                                transition={{ duration: 0.5 }}
                                className="w-full h-full object-contain p-8"
                                loading="lazy"
                            />
                        </AnimatePresence>

                        {/* Navigation Buttons */}
                        <button
                            onClick={prevImage}
                            className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/10 cursor-pointer hover:bg-white/20 backdrop-blur-md border border-white/20 rounded-full p-3 transition-all duration-300 z-20"
                            aria-label="Image précédente"
                        >
                            <ChevronLeft className="w-6 h-6 text-white" />
                        </button>

                        <button
                            onClick={nextImage}
                            className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/10 cursor-pointer hover:bg-white/20 backdrop-blur-md border border-white/20 rounded-full p-3 transition-all duration-300 z-20"
                            aria-label="Image suivante"
                        >
                            <ChevronRight className="w-6 h-6 text-white" />
                        </button>
                    </div>

                    {/* Dots Indicator */}
                    <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-20">
                        {images.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setCurrentImageIndex(index)}
                                className={`w-2 h-2 rounded-full transition-all duration-300 ${index === currentImageIndex
                                    ? "bg-cyan-400 w-8"
                                    : "bg-white/30 hover:bg-white/50"
                                    }`}
                                aria-label={`Aller à l'image ${index + 1}`}
                            />
                        ))}
                    </div>
                </div>

                {/* Floating badge */}
                <div className="absolute -top-4 -right-4 bg-gradient-to-r from-emerald-500 to-emerald-500 text-black px-4 py-2 rounded-full text-xs sm:text-sm font-bold shadow-xl">
                    Application Web
                </div>
            </div>
        </motion.div>
    );
}
